import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'

import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import AuditSearchResults from '../components/AuditSearchResults'
import AuditSearchForm from '../components/AuditSearchForm'
import { searchForAudits, newAuditSearch, findAuditByAuditNumber } from '../actions/searchAuditsAction'

const AuditSearchContainer = ({ searchForAudits, newAuditSearch, auditSearch, user, findAuditByAuditNumber }) => {
  const [values, setValues] = useState({
    auditUnit: '',
    fiscalYear: '',
    auditType: '',
    auditNumber: '',
    organizationId: '',
    organizationName: '',
    auditLocation: '',
    fullAuditNumber: '',
    activeIndicator: ''
  })
  const [canSearchAll, setCanSearchAll] = useState(false)
  const location = useLocation()

  const handleReset = useCallback(
    () => {
    newAuditSearch()
    setValues({
      auditUnit: '',
      fiscalYear: '',
      auditType: '',
      auditNumber: '',
      organizationId: '',
      organizationName: '',
      auditLocation: '',
      fullAuditNumber: '',
      activeIndicator: ''
    })
  }, [newAuditSearch])

  useEffect(() => {
    if (user.authorizations.length > 0) {
      setAuditUnit(user.authorizations)
    }
    return () => handleReset()
  }, [user, handleReset])

  const setAuditUnit = (authorizations) => {
    if ((authorizations.includes('Search All MU Audit File') && authorizations.includes('Search All QA Audit File')) ||
      (authorizations.includes('Search Active MU Audit File') && authorizations.includes('Search Active QA Audit File'))) {
      setCanSearchAll(true)
    } else if ((authorizations.includes('Search All MU Audit File') && !authorizations.includes('Search All QA Audit File')) ||
      (authorizations.includes('Search Active MU Audit File') && !authorizations.includes('Search Active QA Audit File'))) {
      setValues(values => ({ ...values, auditUnit: 'M' }))
    } else if ((authorizations.includes('Search All QA Audit File') && !authorizations.includes('Search All MU Audit File')) ||
      ((authorizations.includes('Search Active QA Audit File') && !authorizations.includes('Search Active MU Audit File')))) {
      setValues(values => ({ ...values, auditUnit: 'Q' }))
    }
  }

  const handleChange = (event) => {
    let target = event.target
    if (target.name === 'fiscalYear' && target.value.length > 4) { target.value = target.value.slice(0, 4) }
    if (target.name === 'organizationId' && target.value.length > 6) { target.value = target.value.slice(0, 6) }
    if (target.name === 'auditNumber' && target.value.length > 3) {
      target.value = target.value.slice(0, 3)
    }

    if (target.name === 'auditUnit' && target.value === 'M') { setValues(values => ({ ...values, auditType: '' })) }

    setValues({ ...values, [target.name]: target.value })
  }

  const handleBlur = (event) => {
    let target = event.target
    if (target.name === 'fullAuditNumber') {
      target.value = target.value.toUpperCase()
    }
    setValues({ ...values, [target.name]: target.value })
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    searchForAudits(values)
  }

  const handleRetrieveAudit = (event) => {
    event.preventDefault()
    findAuditByAuditNumber(values.fullAuditNumber)
  }

  if (auditSearch.fetching || user.fetching) {
    return <LgyLoadingIcon className='audit-search' />
  } else if (auditSearch.list && auditSearch.list.length > 1) {
    return <AuditSearchResults list={auditSearch.list} handleReset={handleReset} />
  } else if (auditSearch.list && auditSearch.list.length === 1) {
    return <Redirect to={{pathname: `/lgyhub/oversight/audits/${auditSearch.list[0].id}`, state: { referer: location.pathname }}} />
  } else {
    return <AuditSearchForm
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleReset={handleReset}
      auditSearch={auditSearch}
      canSearchAll={canSearchAll}
      handleBlur={handleBlur}
      handleRetrieveAudit={handleRetrieveAudit}
      user={user}
      {...values} />
  }
}

const mapStateToProps = state => ({
  auditSearch: state.oversight.auditSearch,
  user: state.currentUser
})

const mapDispatchToProps = { searchForAudits, newAuditSearch, findAuditByAuditNumber }

export default connect(mapStateToProps, mapDispatchToProps)(AuditSearchContainer)
